<div class="border-top px-3 py-1">
  <h5 class="strong text-truncate" title="{{part.description}}" style="max-width: 15rem;">{{part.description || 'No description available.'}}</h5>
  <div class="text-truncate" title="{{part.manufacturer}}">{{part.manufacturer}}</div>
  <div *ngIf="part.hazmat" class="p-3 row">
    <div class="alert alert-danger col-12 mb-0" id="hazmat-errors">
      <span><i class="fas fa-exclamation-triangle"></i> Hazmat products not eligible for freight delivery. In-store pickup and local delivery are still available for this product.</span>
    </div>
  </div>
</div>
